// extracted by mini-css-extract-plugin
export var cardLayout = "_ab-1";
export var paginationContainer = "_ab-0";